import { render, staticRenderFns } from "./lfib.vue?vue&type=template&id=d24c9804&scoped=true"
import script from "./lfib.vue?vue&type=script&lang=js"
export * from "./lfib.vue?vue&type=script&lang=js"
import style0 from "./lfib.vue?vue&type=style&index=0&id=d24c9804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24c9804",
  null
  
)

export default component.exports